import mapboxgl from 'mapbox-gl';
import theme from '../../../theme';

export default function getHighlightGeometryMapboxStyle(
    highlight: MapHighlight
): mapboxgl.Style | undefined {

    if (!highlight || highlight.type !== 'geometry') return undefined;

    return {
        version: 8,
        metadata: {
            uniqueTilecacheKey: 'highlightGeometry'
        },
        sources: {
            source: {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    geometry: highlight.geometry,
                    properties: {}
                },
            }
        },
        layers: [{
            id: 'fill',
            type: 'fill',
            source: 'source',
            filter: ['has', ['geometry-type'], ['literal', {
                Polygon: true,
                MultiPolygon: true,
            }]],
            paint: {
                'fill-color': theme.palette.primary.main,
                'fill-opacity': 0.5
            }
        }, {
            id: 'line',
            type: 'line',
            source: 'source',
            filter: ['has', ['geometry-type'], ['literal', {
                Polygon: true,
                MultiPolygon: true,
                LineString: true,
                MultiLineString: true,
            }]],
            paint: {
                'line-width': 4,
                'line-color': theme.palette.primary.main,
                'line-opacity': 0.75
            }
        }]
    };
}
